import { render, staticRenderFns } from "./ProjectDetailView.vue?vue&type=template&id=22b0ed44&scoped=true&"
import script from "./ProjectDetailView.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailView.vue?vue&type=style&index=0&id=22b0ed44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0ed44",
  null
  
)

export default component.exports